import type { EgressMemberEligibilityReason } from '@nadoutong/contracts';
import type { I18nKey } from '../../i18n/index.ts';

const MEMBER_REASON_KEYS: Record<EgressMemberEligibilityReason, I18nKey> = {
  ok: 'egress_lines.member_reason.ok',
  standby: 'egress_lines.member_reason.standby',
  stale_heartbeat: 'egress_lines.member_reason.stale_heartbeat',
  breaker_open: 'egress_lines.member_reason.breaker_open',
  probe_failing: 'egress_lines.member_reason.probe_failing',
  same_region: 'egress_lines.member_reason.same_region',
};

const SELECTED_REASON_KEYS: Record<
  'policy_direct' | 'policy_cluster' | 'emergency_direct' | 'cluster_down' | 'token_unset',
  I18nKey
> = {
  policy_direct: 'egress_lines.policies.preview.reason.policy_direct',
  policy_cluster: 'egress_lines.policies.preview.reason.policy_cluster',
  emergency_direct: 'egress_lines.policies.preview.reason.emergency_direct',
  cluster_down: 'egress_lines.policies.preview.reason.cluster_down',
  token_unset: 'egress_lines.policies.preview.reason.token_unset',
};

export function memberReasonKey(reason: string): I18nKey {
  if (reason in MEMBER_REASON_KEYS) {
    return MEMBER_REASON_KEYS[reason as EgressMemberEligibilityReason];
  }
  return 'egress_lines.policies.fallback.na';
}

export function selectedReasonKey(reason: string): I18nKey {
  if (reason in SELECTED_REASON_KEYS) {
    return SELECTED_REASON_KEYS[reason as keyof typeof SELECTED_REASON_KEYS];
  }
  return 'egress_lines.policies.fallback.na';
}

export function validationIssueKey(issue: string): I18nKey | null {
  if (issue.includes('same-region')) return 'egress_lines.policies.issue.same_region';
  if (issue === 'rules must be a non-empty array') return 'egress_lines.policies.issue.empty_rules';
  return null;
}
